module.exports = __webpack_public_path__ + "static/media/screenhub_logo.416a8de9.png";